import React, { useCallback, useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { useLoader, useStore } from '../../common/hooks';
import { observer } from 'mobx-react';
import CreatableSelect from 'react-select/creatable';
import { MultiValue, SingleValue } from 'react-select';
import { SuperAdminRequest } from '../../data/Config/SuperAdminManagement/schemas'

import {
    Label,
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from '../../common/materials';


type Props = {
    isOpen?: boolean;
    onClose?: () => void;
};

interface Option {
    readonly label: string;
    readonly value: string;
}

function SuperAdminManagement(props: Props) {
    const { isOpen, onClose } = props;

    const { superAdminManagementStore } = useStore();
    //const { superAdminManagement, fetchSuperAdminManagement, updateSuperAdminManagement } = superAdminManagementStore
    const [superAdminOptions, setSuperAdminOptions] = useState<Option[]>([]);
    const [masterOptions, setMasterOptions] = useState<Option[]>([]);
    const [superAdmin, setSuperAdmin] = useState<MultiValue<Option>>([]);

    const loader = useLoader();

    useEffect(() => {
        //console.log(superAdminManagementStore)
        //fetchSuperAdminManagement();
        (async () => {
            try {
                loader.show();
                //await Promise.all([fetchSuperAdminManagement()]);
                await superAdminManagementStore.fetchSuperAdminManagement();

                const superAdminManagement = superAdminManagementStore.superAdminManagement;
                console.log()
                if (!superAdminManagement) {
                    return;
                }

                //if (masterOptions.length > 0) {
                //    return;
                //}

                const masterUserOption: Option[] = []
                const currentUserOption: Option[] = [/*{ label: '��س����͡ Company...', value: '*' }*/];
                const currentSuperAdminOption: Option[] = [/*{ label: '��س����͡ Company...', value: '*' }*/];

                const superAdminCitizenIdList = superAdminManagement.super_admin_citizen_id_list;
                //console.log(superAdminCitizenIdList);
                superAdminCitizenIdList.forEach(item => {
                    currentSuperAdminOption.push({
                        label: item,
                        value: item
                    });
                    masterUserOption.push({
                        label: item,
                        value: item
                    });
                });

                const otherUserCitizenIdList = superAdminManagement.other_user_citizen_id_list;
                otherUserCitizenIdList.forEach(item => {
                    currentUserOption.push({
                        label: item,
                        value: item
                    });
                    masterUserOption.push({
                        label: item,
                        value: item
                    });
                });

                setSuperAdmin(currentSuperAdminOption);
                setSuperAdminOptions(currentUserOption);
                setMasterOptions(masterUserOption);
            } catch {
            } finally {
                loader.hide();
            }
        })();
    }, []);

    //useEffect(() => {
    //    console.log(superAdminManagement)
    //    if (!superAdminManagement)
    //    {
    //        return;
    //    }

    //    //if (masterOptions.length > 0) {
    //    //    return;
    //    //}

    //    const masterUserOption: Option[] = []
    //    const currentUserOption: Option[] = [/*{ label: '��س����͡ Company...', value: '*' }*/];
    //    const currentSuperAdminOption: Option[] = [/*{ label: '��س����͡ Company...', value: '*' }*/];

    //    const superAdminCitizenIdList = superAdminManagement.super_admin_citizen_id_list;
    //    //console.log(superAdminCitizenIdList);
    //    superAdminCitizenIdList.forEach(item => {
    //        currentSuperAdminOption.push({
    //            label: item,
    //            value: item
    //        });
    //        masterUserOption.push({
    //            label: item,
    //            value: item
    //        });
    //    });
        
    //    const otherUserCitizenIdList = superAdminManagement.other_user_citizen_id_list;
    //    otherUserCitizenIdList.forEach(item => {
    //        currentUserOption.push({
    //            label: item,
    //            value: item
    //        });
    //        masterUserOption.push({
    //            label: item,
    //            value: item
    //        });
    //    });

    //    setSuperAdmin(currentSuperAdminOption);
    //    setSuperAdminOptions(currentUserOption);
    //    setMasterOptions(masterUserOption);
    //}, [superAdminManagement]);

    const handleClickSave = async () => {
        try {
            loader.show();

            const adminList: string[] = [];
            superAdmin.forEach(item => {
                adminList.push(item.value);
            });

            //console.log(adminList);

            const superAdminRequest: SuperAdminRequest = {
                super_admin_citizen_id_list: adminList
            };
            await superAdminManagementStore.updateSuperAdminManagement(superAdminRequest);

            const result = await Swal.fire({
                title: 'Success',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Yes',
                allowOutsideClick: false
            });

            if (result.isConfirmed) {
                onClose && onClose();
                // window.location.reload();
            }

        } catch (e) {
            console.log(e);

            const result = await Swal.fire({
                title: 'Error!',
                text: (e as any).response.data.message,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Yes',
                allowOutsideClick: false
            });

            if (result.isConfirmed) {
                onClose && onClose();
                // window.location.reload();
            }
        } finally {
            loader.hide();
        }
    };

    const onSelectSuperAdmin = (superAdmin: MultiValue<Option>) => {
        // Convert the exclusion list to a Set for performance
        const exclusionSet = new Set(superAdmin);

        // Create a new array including only items not in the exclusionSet
        const updatedItems = masterOptions.filter(item => !exclusionSet.has(item));

        // Update the state with the new array
        setSuperAdminOptions(updatedItems);
        //setSuperAdminOptions(currentUserOption);
        setSuperAdmin(superAdmin);
    }

    return (
        <Modal
            fullscreen
            closeOnClickOverlay
            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalHeader>Super Admin Management</ModalHeader>
            <ModalBody className="flex flex-1 flex-col overflow-y-auto">
                <div className="flex flex-col gap-4 bg-white p-4">
                    <div className="grid grid-cols-1 gap-4">
                        <div className="col-span-2 flex flex-col">
                            <Label>Super Admin</Label>
                            <CreatableSelect
                                className="h-[32px]"
                                //options={companyOptions}
                                //value={company}
                                //onChange={selectedCompany => setCompany(selectedCompany)}
                                //isClearable
                                isMulti
                                onChange={onSelectSuperAdmin}
                                options={superAdminOptions}
                                value={superAdmin}
                            />
                        </div>
                    </div>
                    </div>
            </ModalBody >
            <ModalFooter className="mt-auto flex justify-end gap-4 px-2">
                <Button
                    size="sm"
                    outline
                    className="text-gray-400"
                    onClick={() => onClose && onClose()}
                >
                    Cancel
                </Button>
                <Button
                    size="sm"
                    className="bg-primary-900 text-white"
                    onClick={handleClickSave}
                >
                    Save
                </Button>
            </ModalFooter>
        </Modal >
    );
};

export default SuperAdminManagement;